import { Alert } from 'react-native';
import { mobileLog } from '../../logging';
import { createVriReadCache } from './vriReadCache';
export const VRI_USAGE_CACHE_KEY = 'vri_usage_history_scoped';
export const usageCache = createVriReadCache([VRI_USAGE_CACHE_KEY], 'vri_usage_cache');
/**
 * Fence cached billing reads/writes immediately without delaying sign-out.
 *
 * @returns {void} Starts ordered cleanup with a visible unconfirmed outcome.
 */
export function beginUsageCacheCleanup() {
    usageCache.clear().then(ok => {
        if (!ok) {
            mobileLog('warn', 'vri_usage_cache_cleanup_failed', {});
            try {
                Alert.alert('Saved usage cleanup incomplete', 'This device could not confirm removal of saved usage records. '
                    + 'Offline copies are unavailable until cleanup succeeds. Open Usage and retry to finish cleanup.');
            }
            catch {
                mobileLog('warn', 'vri_usage_cache_cleanup_notice_failed', {});
            }
        }
    });
}
